module.exports = __webpack_public_path__ + "static/img/img_2.de1336a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_2.jpg
// module id = zs4t
// module chunks = 0